// Shared geo helpers for every "find this stone" experience — see StoneMap
// and useVisitorTracking, and "Shared Core, Many Views" in
// docs/architecture/decisions.md.

export function haversineMeters(lat1, lng1, lat2, lng2) {
  const R = 6371000
  const toRad = d => d * Math.PI / 180
  const dLat = toRad(lat2 - lat1)
  const dLng = toRad(lng2 - lng1)
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}

export function distanceLabel(meters) {
  if (meters < 5) return "You've arrived!"
  if (meters < 1000) return `~${Math.round(meters)}m away`
  return `~${(meters / 1000).toFixed(2)}km away`
}

// Opens native turn-by-turn walking directions to a point.
export function openInMaps(lat, lng) {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
  const url = isIOS
    ? `maps://maps.apple.com/?daddr=${lat},${lng}&dirflg=w`
    : `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=walking`
  window.open(url, '_blank')
}
